import { emitConfirmedLead } from "@/lib/analytics-events";
import type { BookCallPopupVariant } from "@/lib/book-call-popup-copy";
import type { Lang } from "@/lib/types";

/** Called only after the contact backend confirms the enquiry was saved. */
export function trackContactLead(lang: Lang): void {
  emitConfirmedLead({ form_id: "contact", method: "contact_form", language: lang }, "contact_form_submit");
}

/** Shared calendar owns this once, for popup and every embedded calendar. */
export function trackBookingLead(lang: Lang, variant: BookCallPopupVariant): void {
  emitConfirmedLead({ form_id: "booking", method: "calendar", booking_variant: variant, language: lang }, "booking_confirmed", "booking");
}
